import { TaxiCarApiTaxiCarListRequest } from '../../openapi'
import appApiClient from './appApiClient'
import useBaseQuery from './useBaseQuery'

export const useTaxiCarListQuery = (req: TaxiCarApiTaxiCarListRequest) =>
  useBaseQuery({
    queryKey: ['taxiCarList'],
    queryFn: (config) => appApiClient.taxiCarApi.taxiCarList(req, config),
  })
